module.exports = __webpack_public_path__ + "static/media/marchi-veronica.b9f3dbf1.jpg";